export default {"src":"/_next/static/media/icon-safe-open.13f62063.svg","height":120,"width":121,"blurWidth":0,"blurHeight":0};